import { useEffect, useRef, useState } from 'react'

import Scrollspy from '@/components/Scrollspy/Scrollspy'
import { useAppSelector } from '@/store/hooks'
import { CardListType, PageCardType } from '@/types/page'
import useDirectories from '@/utils/useDirectories'
import usePatreonTier from '@/utils/usePatreonTier'

import styles from './CardView.module.scss'
import Grid from './Grid'

const CARD_WIDTH = 244

type Props = {
  cardLists?: CardListType[]
  excludeScrollSpy?: boolean
  pageCommander?: PageCardType
}

const CardView = ({ cardLists, excludeScrollSpy, pageCommander }: Props) => {
  const { loading } = useAppSelector((state) => state.cardlists)
  const { query } = useDirectories()
  const patreonTier = usePatreonTier()
  const rightRef = useRef<HTMLDivElement>(null)
  const [numCols, setNumCols] = useState<number>(0)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (isMounted) {
      const handleResize = () => {
        if (rightRef.current) {
          setNumCols(Math.floor(rightRef.current.offsetWidth / CARD_WIDTH))
        }
      }
      handleResize()
      window.addEventListener('resize', handleResize)
      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [isMounted])

  const showAds = !patreonTier || !!query?.ads

  if (!cardLists) return null

  return (
    <>
      {!excludeScrollSpy && cardLists.length > 1 && <Scrollspy cardlists={cardLists} />}
      <div className={styles.right} ref={rightRef}>
        <Grid
          cardLists={cardLists}
          loading={loading}
          numCols={numCols}
          pageCommander={pageCommander}
          showAds={showAds}
        />
      </div>
    </>
  )
}

export default CardView
